import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useAppContext } from "../context/AppContext";
import apiPath from "../constants/apiPath";

const client = axios.create({ baseURL: apiPath.baseURL });

// Mirrors admin-Imergey's useRequest.js hook exactly — one axios instance,
// token from localStorage, 401 auto-logout, loading flag from AppContext.
const useRequest = () => {
  const { logout } = useContext(AuthContext);
  const { setLoading } = useAppContext();

  // `silent: true` skips the global loading overlay — for background polling
  // (notification bell) that shouldn't flash a full-screen spinner over
  // whatever the user is actively doing.
  const request = async ({ url, method: tmethod, data, onSuccess, onError, header, signal, silent = false }) => {
    const method = tmethod.trim().toUpperCase();
    const token = localStorage.getItem("i_ems_admin_token") || "";
    const headers = { ...header, Authorization: `Bearer ${token}` };

    if (!silent) setLoading(true);
    try {
      const response = await client({ url, method, data, headers, signal });
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      // Only force a logout/redirect for a 401 on an already-authenticated
      // request (an expired/invalid session token) — not for a login
      // attempt itself, which has no token yet and legitimately 401s on a
      // wrong password. Without this guard, logout()'s hard page reload
      // (window.location.href) fired immediately on a bad password and
      // wiped out the error toast before it was ever visible.
      if (err?.response?.status === 401 && token) logout();
      if (onError) onError(err);
    } finally {
      if (!silent) setLoading(false);
    }
  };

  return { request };
};

export default useRequest;
